import React from "react";
import "./AsdcPage.css";
import BannerImage from "../Component/asdc.png"; // ✅ Replace with your actual image file

const AsdcPage = () => {
  return (
    <div className="asdc-page">
      {/* 🔹 Banner Section */}
      <div className="asdc-banner">
        <img src={BannerImage} alt="ASDC Banner" className="banner-img" />
       
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 asdc-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About ASDC (Automotive Skills Development Council)
        </h2>

        <p>
          The Automotive Skills Development Council (ASDC) is India’s first sector skill council,
          established to create a skilled workforce for the automotive industry. It operates under
          the guidance of the National Skill Development Corporation (NSDC) and focuses on improving
          technical proficiency, quality, and productivity within the rapidly evolving automotive
          sector. CPIT, as an ASDC-approved training partner, provides specialized training programs
          that align with industry standards and future automotive technologies.
        </p>

        <p>
          ASDC’s primary objective is to bridge the gap between industry requirements and available
          skills by offering structured, hands-on training in vehicle servicing, diagnostics,
          production, and maintenance. CPIT ensures that students not only gain theoretical knowledge
          but also develop practical expertise through modern lab setups, real-time simulations, and
          practical demonstrations that reflect actual automotive workshop environments.
        </p>

        <p>
          Through its collaboration with ASDC, CPIT trains aspiring professionals in various domains
          such as automotive electronics, electric vehicles, body repair, and advanced diagnostic
          systems. The courses are designed in consultation with leading automobile manufacturers,
          ensuring that learners acquire skills relevant to both current and future technologies in
          the automotive ecosystem.
        </p>

        <p>
          Upon completion of ASDC-certified programs, students receive nationally recognized
          certificates that enhance employability in the automobile manufacturing and servicing
          sectors. Many graduates secure positions in reputed companies or start their own workshops.
          These programs play a vital role in supporting India’s “Skill India” mission by creating
          competent, job-ready professionals who contribute effectively to the country’s automotive
          growth.
        </p>
      </div>
    </div>
  );
};

export default AsdcPage;
